"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ArrowDownSmall = _interopRequireDefault(require("../../Icon/core/ArrowDownSmall"));

var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));

var _classnames = _interopRequireDefault(require("classnames"));

var _convertUnsafeMethod = _interopRequireDefault(require("../../utils/convertUnsafeMethod"));

var _createId = _interopRequireDefault(require("../../utils/createId"));

var _FocusManager = require("../../utils/FocusManager");

var _focusRing = _interopRequireDefault(require("../../utils/focusRing"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _class, _temp;

var TableCell = (0, _convertUnsafeMethod["default"])(_class = (0, _focusRing["default"])(_class = (0, _autobindDecorator["default"])(_class = (_temp =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(TableCell, _React$Component);

  function TableCell(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, TableCell);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(TableCell).call(this, props));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      focused: false,
      childFocused: false
    });
    _this.cellId = (0, _createId["default"])();
    return _this;
  }

  (0, _createClass2["default"])(TableCell, [{
    key: "getCellStyle",
    value: function getCellStyle(column) {
      var style = {
        width: column.width,
        minWidth: column.minWidth,
        maxWidth: column.maxWidth
      };

      if (column.width) {
        style.flexShrink = 0;
      } else {
        style.flexGrow = 1;
        style.flexBasis = 0;
      }

      return style;
    }
  }, {
    key: "onKeyPress",
    value: function onKeyPress(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        if (this.props.onClick) {
          e.preventDefault();
          this.props.onClick(e);
        }
      }
    }
  }, {
    key: "onFocus",
    value: function onFocus(e) {
      var cellNode = _reactDom["default"].findDOMNode(this);

      var childFocused = cellNode !== e.target;
      this.setState({
        childFocused: childFocused
      });

      if (!childFocused) {
        // If a child can receive focus, marshall focus to the focusable descendant
        var focusable = cellNode.querySelector(_FocusManager.FOCUSABLE_ELEMENT_SELECTOR);

        if (focusable && focusable !== e.relatedTarget) {
          e.stopPropagation();
          e.preventDefault(); // prevent extra focus events from propagating focusing child

          e.nativeEvent.stopImmediatePropagation();
          focusable.focus();
          return;
        }
      }

      if (this.props.onFocus) {
        this.props.onFocus(e);
      }
    }
  }, {
    key: "onBlur",
    value: function onBlur(e) {
      var cellNode = _reactDom["default"].findDOMNode(this);

      if (cellNode !== e.target && !cellNode.contains(document.activeElement)) {
        this.setState({
          childFocused: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          column = _this$props.column,
          _this$props$id = _this$props.id,
          id = _this$props$id === void 0 ? this.cellId : _this$props$id,
          isHeaderRow = _this$props.isHeaderRow,
          sortDir = _this$props.sortDir,
          onClick = _this$props.onClick,
          onDoubleClick = _this$props.onDoubleClick,
          className = _this$props.className,
          children = _this$props.children,
          allowsMultipleSelection = _this$props.allowsMultipleSelection,
          tabIndex = _this$props.tabIndex,
          rowFocused = _this$props.rowFocused;
      var isSortable = isHeaderRow && column && column.sortable;
      className = (0, _classnames["default"])(className, {
        'spectrum-Table-headCell': isHeaderRow,
        'spectrum-Table-cell': !isHeaderRow,
        'react-spectrum-Table-cell': !isHeaderRow,
        'is-sortable': isSortable,
        'is-sorted-desc': isHeaderRow && sortDir === 1,
        'is-sorted-asc': isHeaderRow && sortDir === -1,
        'spectrum-Table-cell--divider': !isHeaderRow && column && column.divider,
        'spectrum-Table-cell--alignCenter': column && column.align === 'center',
        'spectrum-Table-cell--alignRight': column && column.align === 'right'
      });
      var ariaSort = null;

      if (isSortable) {
        switch (sortDir) {
          case 1:
            ariaSort = 'descending';
            break;

          case -1:
            ariaSort = 'ascending';
            break;

          default:
            ariaSort = 'none';
        }
      }

      if (isSortable) {
        tabIndex = rowFocused || !allowsMultipleSelection ? 0 : -1;
      } else if (tabIndex !== null) {
        tabIndex = this.state.childFocused ? null : -1;
      }

      return (// eslint-disable-next-line jsx-a11y/no-static-element-interactions
        _react["default"].createElement("div", {
          className: className,
          style: column && this.getCellStyle(column),
          onClick: onClick,
          onDoubleClick: onDoubleClick,
          onKeyPress: isSortable ? this.onKeyPress : null,
          onFocus: this.onFocus,
          onBlur: this.onBlur,
          id: id,
          role: isHeaderRow ? 'columnheader' : 'gridcell',
          "aria-sort": ariaSort,
          "aria-label": this.props['aria-label'],
          "aria-colindex": this.props['aria-colindex'],
          tabIndex: tabIndex
        }, children, isSortable && _react["default"].createElement(_ArrowDownSmall["default"], {
          className: "spectrum-Table-sortedIcon",
          size: null
        }))
      );
    }
  }]);
  return TableCell;
}(_react["default"].Component), _temp)) || _class) || _class) || _class;

exports["default"] = TableCell;